import React from "react";
import loadable from "@loadable/component";
import { CircularProgress } from "@mui/material";

const LoadableTasksWork = loadable(() => import("./myWork/ui/TasksWork"), {
  fallback: <CircularProgress />,
});

const LoadableDocumentsWork = loadable(
  () => import("./myWork/ui/DocumentsWork"),
  {
    fallback: <CircularProgress />,
  }
);

const LoadableAccessRestrictionStamp = loadable(
  () => import("./accessRestrictionStamp"),
  {
    fallback: <CircularProgress />,
  }
);

const LoadableTreeCategory = loadable(() => import("./treeCategory"), {
  fallback: <CircularProgress />,
});

const LoadableSettings = loadable(() => import("./settings"), {
  fallback: <CircularProgress />,
});

const LoadableAudit = loadable(() => import("./audit"), {
  fallback: <CircularProgress />,
});

const LoadableUserGroups = loadable(() => import("./userGroups"), {
  fallback: <CircularProgress />,
});

const LoadableDocuments = loadable(() => import("./documents"), {
  fallback: <CircularProgress />,
});

const LoadableCompanies = loadable(() => import("./companies"), {
  fallback: <CircularProgress />,
});

const LoadableUsers = loadable(() => import("./users"), {
  fallback: <CircularProgress />,
});

const LoadableTasks = loadable(() => import("./tasks"), {
  fallback: <CircularProgress />,
});

const LoadableUserProfile = loadable(() => import("./userProfile"), {
  fallback: <CircularProgress />,
});

const LoadableChangeAvatar = loadable(
  () => import("./userProfile/ui/AvatarComponent"),
  {
    fallback: <CircularProgress />,
  }
);

const LoadableChangePass = loadable(
  () => import("./userProfile/ui/ChangePass"),
  {
    fallback: <CircularProgress />,
  }
);

const LoadableChangePersonalData = loadable(
  () => import("./userProfile/ui/ChangePersonalData"),
  {
    fallback: <CircularProgress />,
  }
);

export {
  LoadableAccessRestrictionStamp,
  LoadableTreeCategory,
  LoadableSettings,
  LoadableAudit,
  LoadableUserGroups,
  LoadableDocuments,
  LoadableCompanies,
  LoadableUsers,
  LoadableTasks,
  LoadableUserProfile,
  LoadableTasksWork,
  LoadableDocumentsWork,
  LoadableChangeAvatar,
  LoadableChangePass,
  LoadableChangePersonalData,
};
